import { toast } from 'react-toastify';

const BastidoresTable = ({ bastidores, openMoreInfo }) => {
    const handleCopyBastidor = (bastidor) => {
        navigator.clipboard.writeText(bastidor);
        toast.success(`Bastidor ${bastidor} copiado!`);
    };

    return (
        <div>
            <table className="table">
                <thead>
                    <tr>
                        <th className="text-center">MATRÍCULA</th>
                        <th className="text-center">PAIS</th>
                        <th className="text-center">MARCA</th>
                        <th className="text-center">MODELO</th>
                        <th className="text-center">VERSION</th>
                        <th className="text-center">K-TYPE</th>
                        <th className="text-center">CÓDIGO MOTOR</th>
                        <th className="text-center">BASTIDOR</th>
                        <th className="text-center"></th>
                    </tr>
                </thead>
                <tbody>
                    {bastidores?.results?.map((bastidor) => {
                        return (
                            <tr key={bastidor.id}>
                                <td className="text-center">{bastidor.mat}</td>
                                <td className="text-center">{bastidor.pais}</td>
                                <td className="text-center">
                                    {bastidor.marca}
                                </td>
                                <td className="text-center">
                                    {bastidor.model}
                                </td>
                                <td className="text-center">
                                    {bastidor.version}
                                </td>
                                <td className="text-center">
                                    {bastidor?.AWN_k_type ?? bastidor?.ktype}
                                </td>
                                <td className="text-center">
                                    {bastidor.cod_m}
                                </td>
                                <td
                                    className="text-center"
                                    style={{cursor: 'pointer'}}
                                    title='Clicar para copiar bastidor.'
                                    onClick={() =>
                                        handleCopyBastidor(
                                            bastidor?.bas ?? bastidor?.vin
                                        )
                                    }
                                >
                                    {bastidor?.bas ?? bastidor?.vin}
                                </td>
                                <td
                                    className="text-center"
                                    style={{cursor: 'pointer'}}
                                    onClick={() =>
                                        openMoreInfo(
                                            bastidor?.AWN_k_type ?? bastidor?.ktype
                                        )
                                    }
                                >
                                    <button className='btn btn-primary btn-more-info'>
                                        + Info
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default BastidoresTable;
